import { useProfile } from '@/hooks';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageUploader } from '@/components';
import {
  ProfileControllerUploadUserAvatarApiArg,
  useProfileControllerUploadUserAvatarMutation,
} from '@/store/services/MidleNestApi.service';

export default function ChangeAvatarView() {
  const { t } = useTranslation();
  const [mutation] = useProfileControllerUploadUserAvatarMutation();
  const { profile, reloadProfile } = useProfile();

  const [file, setFile] = useState<File | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleUpload = useCallback(async () => {
    console.log({ file });
    if (!file) return;
    try {
      const formData = new FormData();
      formData.append('file', file);
      // formData.append('campaignId', id ? id : '');
      mutation(formData as ProfileControllerUploadUserAvatarApiArg)
        .unwrap()
        .then(() => {
          setFile(null);
          reloadProfile();
          gtag('event', 'change-avatar', { user: profile.id });
          // hideModal();
          // navigate(-1);
        });
    } catch (err) {
      console.error(err);
    }
  }, [file]);

  return (
    <>
      <div className='bg-white dark:bg-black/20 rounded-3xl mx-auto px-4 md:px-8 py-5 md:py-7 flex flex-col md:mt-0 dark:text-white'>
        <div className='mx-auto flex max-w-md flex-col gap-y-4'>
          <h2 className='text-center text-xl leading-7 font-bold'>
            {t('Upload a Profile Picture')}
          </h2>
          <div>
            <ImageUploader
              setFile={setFile}
              file={file}
              src={profile?.avatar?.src}
              // setError={setError}
              // defaultError={fileError}
              // file={file}
            />
          </div>
          <div className=''>
            {file && (
              <button
                onClick={() => handleUpload()}
                type='button'
                className='btn btn-ok w-full disabled:cursor-not-allowed'
              >
                {t('Upload')}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
